webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(11);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueTransferDom = __webpack_require__(101);
	
	var _vueTransferDom2 = _interopRequireDefault(_vueTransferDom);
	
	var _Root = __webpack_require__(87);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _main = __webpack_require__(16);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _router = __webpack_require__(14);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _registerComponents = __webpack_require__(13);
	
	var _registerComponents2 = _interopRequireDefault(_registerComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(59);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueTransferDom2.default);
	_vue2.default.use(_main2.default);
	
	(0, _registerComponents2.default)(_vue2.default);
	
	_router2.default.start(_Root2.default, '#root');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs sh\">$ npm <span class=hljs-keyword>install</span> ultra-component <span class=hljs-comment>--save</span>\n</code></pre>";

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>ultra-component</span> <span class=hljs-attr>modifier</span>=<span class=hljs-string>\"primary\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>ultra-component</span>&gt;</span>\n</code></pre>";

/***/ },
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerComponents;
	
	var _AppFooter = __webpack_require__(98);
	
	var _AppFooter2 = _interopRequireDefault(_AppFooter);
	
	var _AppTable = __webpack_require__(99);
	
	var _AppTable2 = _interopRequireDefault(_AppTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerComponents(Vue) {
	  Vue.component('app-footer', _AppFooter2.default);
	  Vue.component('app-table', _AppTable2.default);
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(11);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  hashbang: true,
	  history: false,
	  linkActiveClass: 'is-active',
	  transitionOnLoad: true
	});
	
	router.map(_routes.routes);
	
	exports.default = router;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _HomePage = __webpack_require__(96);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _HomeDefaultPage = __webpack_require__(95);
	
	var _HomeDefaultPage2 = _interopRequireDefault(_HomeDefaultPage);
	
	var _HomeUsagePage = __webpack_require__(97);
	
	var _HomeUsagePage2 = _interopRequireDefault(_HomeUsagePage);
	
	var _HomeApiPage = __webpack_require__(94);
	
	var _HomeApiPage2 = _interopRequireDefault(_HomeApiPage);
	
	var _ExamplesPage = __webpack_require__(92);
	
	var _ExamplesPage2 = _interopRequireDefault(_ExamplesPage);
	
	var _ExamplesDefaultPage = __webpack_require__(91);
	
	var _ExamplesDefaultPage2 = _interopRequireDefault(_ExamplesDefaultPage);
	
	var _ExamplesPrimaryPage = __webpack_require__(93);
	
	var _ExamplesPrimaryPage2 = _interopRequireDefault(_ExamplesPrimaryPage);
	
	var _DocsExamplePage = __webpack_require__(89);
	
	var _DocsExamplePage2 = _interopRequireDefault(_DocsExamplePage);
	
	var _DocsMarkdownExamplePage = __webpack_require__(90);
	
	var _DocsMarkdownExamplePage2 = _interopRequireDefault(_DocsMarkdownExamplePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = {
	  '/': {
	    name: 'Home',
	    component: _HomePage2.default,
	    subRoutes: {
	      '/': {
	        name: 'HomeDefaultPage',
	        component: _HomeDefaultPage2.default
	      },
	      '/usage': {
	        name: 'HomeUsagePage',
	        component: _HomeUsagePage2.default
	      },
	      '/api': {
	        name: 'HomeApiPage',
	        component: _HomeApiPage2.default
	      }
	    }
	  },
	  '/examples': {
	    name: 'Examples',
	    component: _ExamplesPage2.default,
	    subRoutes: {
	      '/': {
	        name: 'ExamplesDefaultPage',
	        component: _ExamplesDefaultPage2.default
	      },
	      '/primary': {
	        name: 'ExamplesPrimaryPage',
	        component: _ExamplesPrimaryPage2.default
	      }
	    }
	  },
	  '/docs-example': {
	    name: 'DocsExample',
	    component: _DocsExamplePage2.default
	  },
	  '/docs-markdown-example': {
	    name: 'DocsMarkdownExample',
	    component: _DocsMarkdownExamplePage2.default
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _component = __webpack_require__(100);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vue = {};
	
	var UltraComponent = {
	  install: function install(_Vue) {
	    Vue = _Vue;
	    Vue.component('ultra-component', _component2.default);
	  }
	};
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.component('ultra-component', UltraComponent);
	}
	exports.default = UltraComponent;

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: [{
	    name: 'repoUser',
	    type: String,
	    required: true
	  }, {
	    name: 'repoName',
	    type: String,
	    required: true
	  }, {
	    name: 'background',
	    type: String,
	    default: function _default() {
	      return '#151513';
	    }
	  }, {
	    name: 'color',
	    type: String,
	    default: function _default() {
	      return '#ffffff';
	    }
	  }],
	  computed: {
	    ghLink: function ghLink() {
	      return 'https://github.com/' + this.repoUser + '/' + this.repoName;
	    }
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GhCorner = __webpack_require__(86);
	
	var _GhCorner2 = _interopRequireDefault(_GhCorner);
	
	var _Sidebar = __webpack_require__(88);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Root',
	  components: {
	    GhCorner: _GhCorner2.default,
	    Sidebar: _Sidebar2.default
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installation = __webpack_require__(9);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocsExamplePage',
	  data: function data() {
	    return {
	      snippet: _installation2.default,
	      table: [{
	        name: 'David',
	        gender: 'Male',
	        code: '`0132`',
	        status: false
	      }, {
	        name: 'Other',
	        gender: 'Male',
	        code: '`123`',
	        status: ''
	      }]
	    };
	  }
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _docsMarkdownExample = __webpack_require__(67);
	
	var _docsMarkdownExample2 = _interopRequireDefault(_docsMarkdownExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocsMarkdownExamplePage',
	  data: function data() {
	    return {
	      docsMarkdownExample: _docsMarkdownExample2.default
	    };
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaultExample = __webpack_require__(66);
	
	var _defaultExample2 = _interopRequireDefault(_defaultExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExamplesDefaultPage',
	  data: function data() {
	    return {
	      snippets: {
	        defaultExample: _defaultExample2.default
	      }
	    };
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Examples'
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _primaryExample = __webpack_require__(10);
	
	var _primaryExample2 = _interopRequireDefault(_primaryExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExamplesPrimaryPage',
	  data: function data() {
	    return {
	      snippets: {
	        primaryExample: _primaryExample2.default
	      }
	    };
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HomePage',
	  data: function data() {
	    return {
	      tables: {
	        props: [{
	          name: 'modifier',
	          type: '`string`',
	          required: 'true',
	          default: '`""`'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _installation = __webpack_require__(9);
	
	var _installation2 = _interopRequireDefault(_installation);
	
	var _installationInclude = __webpack_require__(69);
	
	var _installationInclude2 = _interopRequireDefault(_installationInclude);
	
	var _installationCommonjs = __webpack_require__(68);
	
	var _installationCommonjs2 = _interopRequireDefault(_installationCommonjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HomeDefaultPage',
	  data: function data() {
	    return {
	      snippets: {
	        installationInclude: _installationInclude2.default,
	        installation: _installation2.default,
	        installationCommonjs: _installationCommonjs2.default
	      }
	    };
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HomePage'
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _primaryExample = __webpack_require__(10);
	
	var _primaryExample2 = _interopRequireDefault(_primaryExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'HomeUsagePage',
	  data: function data() {
	    return {
	      snippets: {
	        primaryExample: _primaryExample2.default
	      }
	    };
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(32);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _marked2 = __webpack_require__(70);
	
	var _marked3 = _interopRequireDefault(_marked2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      empty: '—<span class="o-screen-reader">none</span>'
	    };
	  },
	
	  props: [{
	    name: 'data',
	    type: Array,
	    required: true
	  }],
	  computed: {
	    columns: function columns() {
	      if (!this.data.length) {
	        return [];
	      }
	
	      return (0, _keys2.default)(this.data[0]);
	    }
	  },
	  methods: {
	    marked: function marked(markdown) {
	      return (0, _marked3.default)(markdown);
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: [{
	    name: 'modifier',
	    type: String,
	    default: ''
	  }],
	  data: function data() {
	    return {
	      counter: 0
	    };
	  }
	};

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 60 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 61 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 62 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 63 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 64 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 65 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-section>&lt;ultra-component&gt;</span><span class=hljs-section>&lt;/ultra-component&gt;</span>\n</code></pre>";

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = "<h1 id=create-pages-using-markdown>Create pages using markdown</h1> <p>Just create a new component in <code>pages</code> folder, and import your markdown file, it will be pre-processed by <a href=https://www.npmjs.com/package/markdown-loader>markdown loader</a> and <a href=https://github.com/webpack/html-loader>html loader</a>.</p> <pre><code class=\"hljs vue\"><span class=hljs-tag>&lt;<span class=hljs-name>template</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>main</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"c-main\"</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>div</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"u-gutter\"</span>&gt;</span>\n      <span class=hljs-comment>&lt;!-- insert plain HTML data --&gt;</span>\n      <span class=hljs-tag>&lt;<span class=hljs-name>article</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"markdown-body c-markdown-body\"</span> <span class=hljs-attr>v-html</span>=<span class=hljs-string>\"docsMarkdownExample\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>article</span>&gt;</span>\n    <span class=hljs-tag>&lt;/<span class=hljs-name>div</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>app-footer</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>app-footer</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>main</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>template</span>&gt;</span>\n\n<span class=hljs-tag>&lt;<span class=hljs-name>script</span>&gt;</span><span class=javascript>\n  <span class=hljs-comment>// import markdown</span>\n  <span class=hljs-keyword>import</span> docsMarkdownExample <span class=hljs-keyword>from</span> <span class=hljs-string>'src-docs/app/snippets/docs-markdown-example.md'</span>\n\n  <span class=hljs-keyword>export</span> <span class=hljs-keyword>default</span> {\n    name: <span class=hljs-string>'DocsMarkdownExamplePage'</span>,\n    data () {\n      <span class=hljs-keyword>return</span> {\n        docsMarkdownExample\n      }\n    }\n  }\n</span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n</code></pre> <p>That&#39;s it!</p> <h1 id=marked>marked</h1> <blockquote> <p>A full-featured markdown parser and compiler, written in JavaScript. Built for speed.</p> </blockquote> <p><a href=http://badge.fury.io/js/marked><img src=https://badge.fury.io/js/marked.png alt=\"NPM version\"></a></p> <h2 id=install>Install</h2> <pre><code class=\"hljs bash\">npm <span class=hljs-keyword>install</span> marked <span class=hljs-comment>--save</span>\n</code></pre> <h2 id=usage>Usage</h2> <p>Minimal usage:</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n<span class=hljs-built_in>console</span>.log(marked(<span class=hljs-string>'I am using __markdown__.'</span>));\n<span class=hljs-comment>// Outputs: &lt;p&gt;I am using &lt;strong&gt;markdown&lt;/strong&gt;.&lt;/p&gt;</span>\n</code></pre> <p>Example setting options with default values:</p> <pre><code class=\"hljs js\">var marked = require(<span class=hljs-string>'marked'</span>);\nmarked.setOptions({\n<span class=hljs-attr>  renderer:</span> new marked.Renderer(),\n<span class=hljs-attr>  gfm:</span> <span class=hljs-literal>true</span>,\n<span class=hljs-attr>  tables:</span> <span class=hljs-literal>true</span>,\n<span class=hljs-attr>  breaks:</span> <span class=hljs-literal>false</span>,\n<span class=hljs-attr>  pedantic:</span> <span class=hljs-literal>false</span>,\n<span class=hljs-attr>  sanitize:</span> <span class=hljs-literal>false</span>,\n<span class=hljs-attr>  smartLists:</span> <span class=hljs-literal>true</span>,\n<span class=hljs-attr>  smartypants:</span> <span class=hljs-literal>false</span>\n});\n\nconsole.log(marked(<span class=hljs-string>'I am using __markdown__.'</span>));\n</code></pre> <h3 id=browser>Browser</h3> <pre><code class=\"hljs html\"><span class=hljs-meta>&lt;!doctype html&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>html</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>head</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>meta</span> <span class=hljs-attr>charset</span>=<span class=hljs-string>\"utf-8\"</span>/&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>title</span>&gt;</span>Marked in the browser<span class=hljs-tag>&lt;/<span class=hljs-name>title</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"lib/marked.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>head</span>&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>body</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>div</span> <span class=hljs-attr>id</span>=<span class=hljs-string>\"content\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>div</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>script</span>&gt;</span><span class=javascript>\n    <span class=hljs-built_in>document</span>.getElementById(<span class=hljs-string>'content'</span>).innerHTML =\n      marked(<span class=hljs-string>'# Marked in browser\\n\\nRendered by **marked**.'</span>);\n  </span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>body</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>html</span>&gt;</span>\n</code></pre> <h2 id=marked-markdownstring-options-callback->marked(markdownString [,options] [,callback])</h2> <h3 id=markdownstring>markdownString</h3> <p>Type: <code>string</code></p> <p>String of markdown source to be compiled.</p> <h3 id=options>options</h3> <p>Type: <code>object</code></p> <p>Hash of options. Can also be set using the <code>marked.setOptions</code> method as seen above.</p> <h3 id=callback>callback</h3> <p>Type: <code>function</code></p> <p>Function called when the <code>markdownString</code> has been fully parsed when using async highlighting. If the <code>options</code> argument is omitted, this can be used as the second argument.</p> <h2 id=options>Options</h2> <h3 id=highlight>highlight</h3> <p>Type: <code>function</code></p> <p>A function to highlight code blocks. The first example below uses async highlighting with <a href=https://github.com/rvagg/node-pygmentize-bundled>node-pygmentize-bundled</a>, and the second is a synchronous example using <a href=https://github.com/isagalaev/highlight.js>highlight.js</a>:</p> <pre><code class=\"hljs js\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n\n<span class=hljs-keyword>var</span> markdownString = <span class=hljs-string>'```js\\n console.log(\"hello\"); \\n```'</span>;\n\n<span class=hljs-comment>// Async highlighting with pygmentize-bundled</span>\nmarked.setOptions({\n  highlight: <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>code, lang, callback</span>) </span>{\n    <span class=hljs-built_in>require</span>(<span class=hljs-string>'pygmentize-bundled'</span>)({ lang: lang, format: <span class=hljs-string>'html'</span> }, code, <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>err, result</span>) </span>{\n      callback(err, result.toString());\n    });\n  }\n});\n\n<span class=hljs-comment>// Using async version of marked</span>\nmarked(markdownString, <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>err, content</span>) </span>{\n  <span class=hljs-keyword>if</span> (err) <span class=hljs-keyword>throw</span> err;\n  <span class=hljs-built_in>console</span>.log(content);\n});\n\n<span class=hljs-comment>// Synchronous highlighting with highlight.js</span>\nmarked.setOptions({\n  highlight: <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>code</span>) </span>{\n    <span class=hljs-keyword>return</span> <span class=hljs-built_in>require</span>(<span class=hljs-string>'highlight.js'</span>).highlightAuto(code).value;\n  }\n});\n\n<span class=hljs-built_in>console</span>.log(marked(markdownString));\n</code></pre> <h4 id=highlight-arguments>highlight arguments</h4> <p><code>code</code></p> <p>Type: <code>string</code></p> <p>The section of code to pass to the highlighter.</p> <p><code>lang</code></p> <p>Type: <code>string</code></p> <p>The programming language specified in the code block.</p> <p><code>callback</code></p> <p>Type: <code>function</code></p> <p>The callback function to call when using an async highlighter.</p> <h3 id=renderer>renderer</h3> <p>Type: <code>object</code> Default: <code>new Renderer()</code></p> <p>An object containing functions to render tokens to HTML.</p> <h4 id=overriding-renderer-methods>Overriding renderer methods</h4> <p>The renderer option allows you to render tokens in a custom manner. Here is an example of overriding the default heading token rendering by adding an embedded anchor tag like on GitHub:</p> <pre><code class=\"hljs javascript\"><span class=hljs-keyword>var</span> marked = <span class=hljs-built_in>require</span>(<span class=hljs-string>'marked'</span>);\n<span class=hljs-keyword>var</span> renderer = <span class=hljs-keyword>new</span> marked.Renderer();\n\nrenderer.heading = <span class=hljs-function><span class=hljs-keyword>function</span> (<span class=hljs-params>text, level</span>) </span>{\n  <span class=hljs-keyword>var</span> escapedText = text.toLowerCase().replace(<span class=hljs-regexp>/[^\\w]+/g</span>, <span class=hljs-string>'-'</span>);\n\n  <span class=hljs-keyword>return</span> <span class=hljs-string>'&lt;h'</span> + level + <span class=hljs-string>'&gt;&lt;a name=\"'</span> +\n                escapedText +\n                 <span class=hljs-string>'\" class=\"anchor\" href=\"#'</span> +\n                 escapedText +\n                 <span class=hljs-string>'\"&gt;&lt;span class=\"header-link\"&gt;&lt;/span&gt;&lt;/a&gt;'</span> +\n                  text + <span class=hljs-string>'&lt;/h'</span> + level + <span class=hljs-string>'&gt;'</span>;\n},\n\n<span class=hljs-built_in>console</span>.log(marked(<span class=hljs-string>'# heading+'</span>, { renderer: renderer }));\n</code></pre> <p>This code will output the following HTML:</p> <pre><code class=\"hljs html\">&lt;h1&gt;\n  <span class=xml><span class=hljs-tag>&lt;<span class=hljs-name>a</span> <span class=hljs-attr>name</span>=<span class=hljs-string>\"heading-\"</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"anchor\"</span> <span class=hljs-attr>href</span>=<span class=hljs-string>\"#heading-\"</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>span</span> <span class=hljs-attr>class</span>=<span class=hljs-string>\"header-link\"</span>&gt;</span><span class=hljs-tag>&lt;/<span class=hljs-name>span</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>a</span>&gt;</span></span>\n  heading+\n<span class=xml><span class=hljs-tag>&lt;/<span class=hljs-name>h1</span>&gt;</span></span>\n</code></pre> <h4 id=block-level-renderer-methods>Block level renderer methods</h4> <ul> <li>code(<em>string</em> code, <em>string</em> language)</li> <li>blockquote(<em>string</em> quote)</li> <li>html(<em>string</em> html)</li> <li>heading(<em>string</em> text, <em>number</em> level)</li> <li>hr()</li> <li>list(<em>string</em> body, <em>boolean</em> ordered)</li> <li>listitem(<em>string</em> text)</li> <li>paragraph(<em>string</em> text)</li> <li>table(<em>string</em> header, <em>string</em> body)</li> <li>tablerow(<em>string</em> content)</li> <li>tablecell(<em>string</em> content, <em>object</em> flags)</li> </ul> <p><code>flags</code> has the following properties:</p> <pre><code class=\"hljs js\">{\n    <span class=hljs-symbol>header:</span> <span class=hljs-literal>true</span> <span class=hljs-params>||</span> <span class=hljs-literal>false</span>,\n    <span class=hljs-symbol>align:</span> <span class=hljs-string>'center'</span> <span class=hljs-params>||</span> <span class=hljs-string>'left'</span> <span class=hljs-params>||</span> <span class=hljs-string>'right'</span>\n}\n</code></pre> <h4 id=inline-level-renderer-methods>Inline level renderer methods</h4> <ul> <li>strong(<em>string</em> text)</li> <li>em(<em>string</em> text)</li> <li>codespan(<em>string</em> code)</li> <li>br()</li> <li>del(<em>string</em> text)</li> <li>link(<em>string</em> href, <em>string</em> title, <em>string</em> text)</li> <li>image(<em>string</em> href, <em>string</em> title, <em>string</em> text)</li> </ul> <h3 id=gfm>gfm</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Enable <a href=https://help.github.com/articles/github-flavored-markdown>GitHub flavored markdown</a>.</p> <h3 id=tables>tables</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Enable GFM <a href=https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet#wiki-tables>tables</a>. This option requires the <code>gfm</code> option to be true.</p> <h3 id=breaks>breaks</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Enable GFM <a href=https://help.github.com/articles/github-flavored-markdown#newlines>line breaks</a>. This option requires the <code>gfm</code> option to be true.</p> <h3 id=pedantic>pedantic</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Conform to obscure parts of <code>markdown.pl</code> as much as possible. Don&#39;t fix any of the original markdown bugs or poor behavior.</p> <h3 id=sanitize>sanitize</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Sanitize the output. Ignore any HTML that has been input.</p> <h3 id=smartlists>smartLists</h3> <p>Type: <code>boolean</code> Default: <code>true</code></p> <p>Use smarter list behavior than the original markdown. May eventually be default with the old behavior moved into <code>pedantic</code>.</p> <h3 id=smartypants>smartypants</h3> <p>Type: <code>boolean</code> Default: <code>false</code></p> <p>Use &quot;smart&quot; typograhic punctuation for things like quotes and dashes.</p> <h2 id=access-to-lexer-and-parser>Access to lexer and parser</h2> <p>You also have direct access to the lexer and parser if you so desire.</p> <pre><code class=\"hljs js\"><span class=hljs-built_in>var</span> <span class=hljs-built_in>tokens</span> = marked.lexer(text, options);\nconsole.<span class=hljs-built_in>log</span>(marked.parser(<span class=hljs-built_in>tokens</span>));\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-built_in>var</span> lexer = <span class=hljs-built_in>new</span> marked.Lexer(options);\n<span class=hljs-built_in>var</span> <span class=hljs-built_in>tokens</span> = lexer.lex(text);\nconsole.<span class=hljs-built_in>log</span>(<span class=hljs-built_in>tokens</span>);\nconsole.<span class=hljs-built_in>log</span>(lexer.rules);\n</code></pre> <h2 id=cli>CLI</h2> <pre><code class=\"hljs bash\">$ marked -o hello<span class=hljs-selector-class>.html</span>\nhello world\n^D\n$ cat hello<span class=hljs-selector-class>.html</span>\n&lt;p&gt;hello world&lt;/p&gt;\n</code></pre> <h2 id=philosophy-behind-marked>Philosophy behind marked</h2> <p>The point of marked was to create a markdown compiler where it was possible to frequently parse huge chunks of markdown without having to worry about caching the compiled output somehow...or blocking for an unnecesarily long time.</p> <p>marked is very concise and still implements all markdown features. It is also now fully compatible with the client-side.</p> <p>marked more or less passes the official markdown test suite in its entirety. This is important because a surprising number of markdown compilers cannot pass more than a few tests. It was very difficult to get marked as compliant as it is. It could have cut corners in several areas for the sake of performance, but did not in order to be exactly what you expect in terms of a markdown rendering. In fact, this is why marked could be considered at a disadvantage in the benchmarks above.</p> <p>Along with implementing every markdown feature, marked also implements <a href=http://github.github.com/github-flavored-markdown/ >GFM features</a>.</p> <h2 id=benchmarks>Benchmarks</h2> <p>node v0.8.x</p> <pre><code class=\"hljs bash\">$ <span class=hljs-keyword>node</span> <span class=hljs-title>test</span> --bench\nmarked completed <span class=hljs-keyword>in</span> <span class=hljs-number>3411ms</span>.\nmarked (gfm) completed <span class=hljs-keyword>in</span> <span class=hljs-number>3727ms</span>.\nmarked (pedantic) completed <span class=hljs-keyword>in</span> <span class=hljs-number>3201ms</span>.\nrobotskirt completed <span class=hljs-keyword>in</span> <span class=hljs-number>808ms</span>.\nshowdown (reuse converter) completed <span class=hljs-keyword>in</span> <span class=hljs-number>11954ms</span>.\nshowdown (new converter) completed <span class=hljs-keyword>in</span> <span class=hljs-number>17774ms</span>.\nmarkdown-js completed <span class=hljs-keyword>in</span> <span class=hljs-number>17191ms</span>.\n</code></pre> <p><strong>Marked is now faster than Discount, which is written in C.</strong></p> <p>For those feeling skeptical: These benchmarks run the entire markdown test suite 1000 times. The test suite tests every feature. It doesn&#39;t cater to specific aspects.</p> <h3 id=pro-level>Pro level</h3> <p>You also have direct access to the lexer and parser if you so desire.</p> <pre><code class=\"hljs js\"><span class=hljs-built_in>var</span> <span class=hljs-built_in>tokens</span> = marked.lexer(text, options);\nconsole.<span class=hljs-built_in>log</span>(marked.parser(<span class=hljs-built_in>tokens</span>));\n</code></pre> <pre><code class=\"hljs js\"><span class=hljs-built_in>var</span> lexer = <span class=hljs-built_in>new</span> marked.Lexer(options);\n<span class=hljs-built_in>var</span> <span class=hljs-built_in>tokens</span> = lexer.lex(text);\nconsole.<span class=hljs-built_in>log</span>(<span class=hljs-built_in>tokens</span>);\nconsole.<span class=hljs-built_in>log</span>(lexer.rules);\n</code></pre> <pre><code class=\"hljs bash\">$ node\n&gt; require(<span class=hljs-symbol>'marke</span>d').lexer('&gt; i am using marked.')\n[ { <span class=hljs-class><span class=hljs-keyword>type</span></span>: <span class=hljs-symbol>'blockquote_star</span>t' },\n  { <span class=hljs-class><span class=hljs-keyword>type</span></span>: <span class=hljs-symbol>'paragrap</span>h',\n    text: <span class=hljs-symbol>'i</span> am using marked.' },\n  { <span class=hljs-class><span class=hljs-keyword>type</span></span>: <span class=hljs-symbol>'blockquote_en</span>d' },\n  links: {} ]\n</code></pre> <h2 id=running-tests-contributing>Running Tests &amp; Contributing</h2> <p>If you want to submit a pull request, make sure your changes pass the test suite. If you&#39;re adding a new feature, be sure to add your own test.</p> <p>The marked test suite is set up slightly strangely: <code>test/new</code> is for all tests that are not part of the original markdown.pl test suite (this is where your test should go if you make one). <code>test/original</code> is only for the original markdown.pl tests. <code>test/tests</code> houses both types of tests after they have been combined and moved/generated by running <code>node test --fix</code> or <code>marked --test --fix</code>.</p> <p>In other words, if you have a test to add, add it to <code>test/new/</code> and then regenerate the tests with <code>node test --fix</code>. Commit the result. If your test uses a certain feature, for example, maybe it assumes GFM is <em>not</em> enabled, you can add <code>.nogfm</code> to the filename. So, <code>my-test.text</code> becomes <code>my-test.nogfm.text</code>. You can do this with any marked option. Say you want line breaks and smartypants enabled, your filename should be: <code>my-test.breaks.smartypants.text</code>.</p> <p>To run the tests:</p> <pre><code class=\"hljs bash\">cd marked/\n<span class=hljs-keyword>node</span> <span class=hljs-title>test</span>\n</code></pre> <h3 id=contribution-and-license-agreement>Contribution and License Agreement</h3> <p>If you contribute code to this project, you are implicitly allowing your code to be distributed under the MIT license. You are also implicitly verifying that all code is your original work. <code>&lt;/legalese&gt;</code></p> <h2 id=license>License</h2> <p>Copyright (c) 2011-2014, Christopher Jeffrey. (MIT License)</p> <p>See LICENSE for more info.</p>";

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs js\"><span class=hljs-comment>// app.js</span>\n\n<span class=hljs-built_in>require</span>(<span class=hljs-string>'ultra-component/dist/ultra-component.css'</span>)\n\n<span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>\n<span class=hljs-keyword>import</span> UltraComponent <span class=hljs-keyword>from</span> <span class=hljs-string>'ultra-component'</span>\n\nVue.use(UltraComponent)\n</code></pre>";

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = "<pre><code class=\"hljs html\"><span class=hljs-meta>&lt;!DOCTYPE html&gt;</span>\n<span class=hljs-tag>&lt;<span class=hljs-name>html</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>head</span>&gt;</span>\n    ...\n    <span class=hljs-tag>&lt;<span class=hljs-name>link</span> <span class=hljs-attr>rel</span>=<span class=hljs-string>\"stylesheet\"</span> <span class=hljs-attr>href</span>=<span class=hljs-string>\"path/to/ultra-component.css\"</span>/&gt;</span>\n    ...\n  <span class=hljs-tag>&lt;/<span class=hljs-name>head</span>&gt;</span>\n  <span class=hljs-tag>&lt;<span class=hljs-name>body</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"path/to/vue.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"path/to/ultra-component.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n    <span class=hljs-tag>&lt;<span class=hljs-name>script</span> <span class=hljs-attr>src</span>=<span class=hljs-string>\"path/to/app.js\"</span>&gt;</span><span class=undefined></span><span class=hljs-tag>&lt;/<span class=hljs-name>script</span>&gt;</span>\n  <span class=hljs-tag>&lt;/<span class=hljs-name>body</span>&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>html</span>&gt;</span>\n</code></pre>";

/***/ },
/* 70 */,
/* 71 */
/***/ function(module, exports) {

	module.exports = " <div> <a class=github-corner v-transfer-dom :href=ghLink target=_blank rel=\"noopener noreferrer\" aria-label=\"View source on Github\" title=\"View source on Github\"> <svg width=80 height=80 viewBox=\"0 0 250 250\" :style=\"{fill: background, color: color, position: 'absolute', top: 0, border: 0, right: 0}\" aria-hidden=true> <path d=\"M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z\"></path> <path class=octo-arm d=\"M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2\" fill=currentColor style=\"transform-origin: 130px 106px\"></path> <path class=octo-body d=\"M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z\" fill=currentColor></path> </svg> </a> </div> ";

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = " <div> <sidebar></sidebar> <router-view></router-view> <gh-corner repo-user=wovue repo-name=ultra-component color=#EAE8EB background=#dd5a6f></gh-corner> </div> ";

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = " <header class=c-sidebar> <h1 class=c-sidebar__header> <a href=#!>ultra-component</a> </h1> <nav class=c-sidebar__body role=navigation> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'Home', exact: true}\">Getting started</a> </li> <li> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeDefaultPage', exact: true}\">Installation</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeUsagePage'}\">Usage</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'HomeApiPage'}\">Api</a> </li> </ul> </li> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'Examples'}\">Examples</a> </li> <li> <ul class=o-reset-list> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'ExamplesDefaultPage', exact: true}\">Default</a> </li> <li class=\"c-sidebar__item c-sidebar__item--sub-heading\"> <a v-link=\"{name: 'ExamplesPrimaryPage'}\">Primary</a> </li> </ul> </li> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'DocsExample'}\">Page boilerplate</a> </li> <li class=\"c-sidebar__item c-sidebar__item--heading\"> <a v-link=\"{name: 'DocsMarkdownExample'}\">Markdown page boilerplate</a> </li> </ul> </nav> </header> ";

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main> <section class=c-main__section> <header> <h2 class=\"c-main__heading u-gutter\">Main title</h2> </header> <section> <h3 class=\"c-main__sub-heading u-gutter\">Main sub title</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>Item title</h4> <div class=c-item__description> <p>Description</p> </div> <h5 class=c-item__sub-heading>Item sub title</h5> <div class=c-item__code-wrapper v-html=snippet></div> <h5 class=c-item__sub-heading>Table</h5> <app-table :data=table></app-table> </div> </section> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main> <div class=u-gutter> <article class=\"markdown-body c-markdown-body\" v-html=docsMarkdownExample></article> </div> <app-footer></app-footer> </main> ";

/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = " <div> <h3 class=c-main__sub-heading>Default</h3> <div class=\"c-item u-gutter\"> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.defaultExample></div> <h5 class=c-item__sub-heading>Result:</h5> <ultra-component></ultra-component> </div> </div> ";

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main> <section class=c-main__section> <h2 class=c-main__heading>Examples</h2> <router-view></router-view> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = " <div> <h3 class=c-main__sub-heading>Primary</h3> <div class=\"c-item u-gutter\"> <h5 class=c-item__sub-heading>Code:</h5> <div class=c-item__code-wrapper v-html=snippets.primaryExample></div> <h5 class=c-item__sub-heading>Result:</h5> <ultra-component modifier=primary></ultra-component> </div> </div> ";

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = " <section> <h3 class=\"c-main__sub-heading u-gutter\">API</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>UltraComponent</h4> <h5 class=c-item__sub-heading>Props</h5> <app-table :data=tables.props></app-table> </div> </section> ";

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = " <section> <h3 class=\"c-main__sub-heading u-gutter\">Installation</h3> <div class=\"c-item u-gutter\"> <div class=c-item__code-wrapper v-html=snippets.installation></div> <div class=c-item__description> <p>You have two ways to setup ultra-component:</p> </div> <h5 class=c-item__sub-heading>Include</h5> <div class=c-item__description> <p>Include it directly with a <code>&lt;script&gt;</code> tag. In this case, you don't need to write <code>Vue.use(UltraComponent)</code>, this will be done automatically for you.</p> </div> <div class=c-item__code-wrapper v-html=snippets.installationInclude></div> <h5 class=c-item__sub-heading>CommonJS (Webpack/Browserify)</h5> <div class=c-item__code-wrapper v-html=snippets.installationCommonjs></div> </div> </section> ";

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = " <main class=c-main role=main> <section class=c-main__section> <header> <h2 class=\"c-main__heading u-gutter\">Getting started</h2> </header> <router-view></router-view> </section> <app-footer></app-footer> </main> ";

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = " <section> <h3 class=\"c-main__sub-heading u-gutter\">Usage</h3> <div class=\"c-item u-gutter\"> <div class=c-item__description> <p>Here's an example:</p> </div> <h4 class=c-item__heading>UltraComponent</h4> <div class=c-item__code-wrapper v-html=snippets.primaryExample></div> <div class=c-item__description> <p>That's it!</p> </div> </div> </section> ";

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = " <footer class=\"c-footer u-gutter\" role=contentinfo> <a href=https://github.com/wovue/component-template/tree/master target=_blank rel=\"noopener noreferrer\">Wovue component template</a> <a href=https://github.com/SassDoc/sassdoc-theme-default target=_blank rel=\"noopener noreferrer\">SassDoc Default Theme</a> </footer> ";

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = " <table class=c-item__parameters> <thead> <tr> <th v-for=\"column in columns\" scope=col><span class=o-screen-reader>{{ heading }} </span>{{ column }}</th> </tr> </thead> <tbody> <tr v-for=\"row in data\" class=c-item__parameter> <td v-for=\"column in columns\" scope=row :data-label=column>{{{ row[column] ? marked(row[column]) : empty }}}</td> </tr> </tbody> </table> ";

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = " <div class=counter :class=\"`counter--${modifier}`\"> <button @click=\"counter += 1\" type=button aria-label=increment>+</button> <input v-model=counter type=text disabled=true /> <button @click=\"counter -= 1\" type=button aria-label=decrement>-</button> </div> ";

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(60)
	__vue_script__ = __webpack_require__(17)
	__vue_template__ = __webpack_require__(71)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(18)
	__vue_template__ = __webpack_require__(72)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(61)
	__vue_script__ = __webpack_require__(19)
	__vue_template__ = __webpack_require__(73)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(62)
	__vue_script__ = __webpack_require__(20)
	__vue_template__ = __webpack_require__(74)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(21)
	__vue_template__ = __webpack_require__(75)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(22)
	__vue_template__ = __webpack_require__(76)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(77)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(78)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(79)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(26)
	__vue_template__ = __webpack_require__(80)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(27)
	__vue_template__ = __webpack_require__(81)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(28)
	__vue_template__ = __webpack_require__(82)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(63)
	__vue_script__ = __webpack_require__(29)
	__vue_template__ = __webpack_require__(83)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(64)
	__vue_script__ = __webpack_require__(30)
	__vue_template__ = __webpack_require__(84)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(65)
	__vue_script__ = __webpack_require__(31)
	__vue_template__ = __webpack_require__(85)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.js
 **/